import { validateBiggerOrEqual } from "../../uikit.helpers/validators.es.js";
function getParams(params) {
  if (!params) {
    return {
      min: 0
    };
  }
  if (Array.isArray(params)) {
    return { min: params[0] };
  }
  return params;
}
const biggerOrEqualValidator = (value, params) => {
  if (value === void 0 || value === "" || value === null) {
    return true;
  }
  const { min } = getParams(params);
  return validateBiggerOrEqual(value, { min });
};
export {
  biggerOrEqualValidator as default
};
//# sourceMappingURL=bigger-or-Equal.es.js.map
